/** Delimiter the model emits between its free-text reasoning and the final JSON object. */
export const BRIEF_AI_JSON_DELIMITER = '<<<BRIEF_JSON>>>';

/** Returns the streamed reasoning prose, excluding anything after the JSON delimiter. */
export function extractThoughtsFromStream(
  full: string,
  delimiter = BRIEF_AI_JSON_DELIMITER,
): string {
  const delimiterIndex = full.indexOf(delimiter);
  return delimiterIndex >= 0 ? full.slice(0, delimiterIndex) : full;
}

/** Extracts the first JSON object after the delimiter (or the first object in the full text). */
export function extractJsonFromStream(
  full: string,
  delimiter = BRIEF_AI_JSON_DELIMITER,
): string | undefined {
  let candidate = full;
  const delimiterIndex = full.indexOf(delimiter);
  if (delimiterIndex >= 0) {
    candidate = full.slice(delimiterIndex + delimiter.length);
  }
  candidate = candidate.replace(/```json/gi, '').replace(/```/g, '').trim();
  const start = candidate.indexOf('{');
  const end = candidate.lastIndexOf('}');
  if (start === -1 || end === -1 || end <= start) {
    return undefined;
  }
  return candidate.slice(start, end + 1);
}

/** Parses the JSON object after the delimiter. Returns null when the payload is missing or invalid. */
export function parseJsonAfterDelimiter<T>(
  full: string,
  delimiter = BRIEF_AI_JSON_DELIMITER,
): T | null {
  const jsonText = extractJsonFromStream(full, delimiter);
  if (!jsonText) {
    return null;
  }
  try {
    return JSON.parse(jsonText) as T;
  } catch {
    return null;
  }
}
